var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeatUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41820_9145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41820_9145",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41820_9145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.625C7.3125 5.625 8.125 4.8125 8.125 3.75C8.125 2.6875 7.3125 1.875 6.25 1.875C5.1875 1.875 4.375 2.6875 4.375 3.75C4.375 4.8125 5.1875 5.625 6.25 5.625ZM6.25 3.125C6.625 3.125 6.875 3.375 6.875 3.75C6.875 4.125 6.625 4.375 6.25 4.375C5.875 4.375 5.625 4.125 5.625 3.75C5.625 3.375 5.875 3.125 6.25 3.125ZM12.0625 17.1875C12.1875 17.5625 12.125 17.9375 11.875 18.3125C11.625 18.6875 11.25 18.75 10.8125 18.75H5V17.5H10.875L10.1875 15H6.0625C5.5 15 5 14.625 4.875 14.0625L1.25 1.25H1.625C2.1875 1.25 2.6875 1.625 2.8125 2.1875L6.0625 13.75H11.0625L12.0625 17.1875ZM15 18.75H13.6875L11.875 12.5H6.875L5.5625 7.8125C5.4375 7.4375 5.5 7.0625 5.75 6.6875C6 6.375 6.375 6.1875 6.75 6.1875C8 6.1875 9.125 7.0625 9.5 8.25L10.1875 10.5625H8.875L8.3125 8.5625C8.125 8 7.5 7.5 6.8125 7.5L7.875 11.25H11.9375C12.5 11.25 13 11.625 13.125 12.1875L15 18.75ZM15 1.25C12.9375 1.25 11.25 2.9375 11.25 5C11.25 7.0625 12.9375 8.75 15 8.75C17.0625 8.75 18.75 7.0625 18.75 5C18.75 2.9375 17.0625 1.25 15 1.25ZM16.5625 5.3125L15.5 4.25V7.5H14.5625V4.25L13.5 5.3125L12.8125 4.625L15 2.4375L17.1875 4.625L16.5625 5.3125Z",
    fill: "#BFA247"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41820_9145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeatUpgrade);
export default __webpack_public_path__ + "static/media/icon-seat-upgrade.50b6f1f919d516f83cbdc2379cd882f7.svg";
export { ForwardRef as ReactComponent };